import { defineMessages } from 'react-intl';

export default defineMessages({
  requestAdditionalFeedback: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.request-additional-feedback',
    defaultMessage: 'Thanks for your feedback. ',
    description:
      'The text shown to the user when they vote up or down on a comment.',
  },
  additionalFeedbackButtonText: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.additional-feedback-button-text',
    defaultMessage: 'Add detailed feedback',
    description: 'Text shown on the button.',
  },
  feedbackTitle: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.feedback-title',
    defaultMessage: 'Give feedback about Code Reviewer',
    description:
      'The title shown at the top of the feedback form encouraging users to leave feedback',
  },
  textboxLabel: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.textbox-label',
    defaultMessage: 'Whats on your mind?',
    description:
      'The checkbox label letting users enrol themselves in future product research interviews',
  },
  enrolInResearchLabel: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.enrol-in-research-label',
    defaultMessage: "I'd like to participate in product research",
    description:
      'The checkbox label letting users enrol themselves in future product research interviews',
  },
  canBeContactedLabel: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.can-be-contacted-label',
    defaultMessage:
      'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the {privacyPolicyLink}.',
    description:
      'The checkbox label to give consent to be contacted about their feedback',
  },
  summaryPlaceholder: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.summary-placeholder',
    defaultMessage: "Let us know what's on your mind",
    description:
      'The textarea label listing feedback categories (bug, suggestions, questions, comments)',
  },
  formCommentLabel: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.form-comment-label',
    defaultMessage: "Let us know what's on your mind",
    description: 'The textarea label where users can write their comment',
  },
  submitButtonLabel: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.submit-button-label',
    defaultMessage: 'Send feedback',
    description: 'The button to submit the feedback form',
  },
  cancelButtonLabel: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.cancel-button-label',
    defaultMessage: 'Cancel',
    description: 'The button to cancel feedback submission',
  },
  giveFeedback: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.give-feedback',
    defaultMessage: 'Give feedback',
    description: 'The button that allows users to give feedback',
  },
  formBugLabel: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.form-bug-label',
    defaultMessage: 'Describe the bug or issue',
    description:
      'The textarea label where users can describe the bug or issue they have',
  },
  formSuggestionLabel: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.form-suggestion-label',
    defaultMessage: "Let us know what you'd like to improve",
    description: 'The textarea label where users can write their suggestion',
  },
  formQuestionLabel: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.form-question-label',
    defaultMessage: 'What would you like to know?',
    description: 'The textarea label where users can write their question',
  },
  formEmptyLabel: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.form-empty-label',
    defaultMessage: 'Select an option',
    description: 'The default dropdown list option',
  },
  selectionOptionQuestionLabel: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.selection-option-question-label',
    defaultMessage: 'Ask a question',
    description: 'The feedback dropdown list option to ask a question',
  },
  selectionOptionCommentLabel: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.selection-option-comment-label',
    defaultMessage: 'Leave a comment',
    description: 'The feedback dropdown list option to leave a comment',
  },
  selectionOptionBugLabel: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.selection-option-bug-label',
    defaultMessage: 'Report a bug',
    description: 'The feedback dropdown list option to report a bug',
  },
  selectionOptionSuggestionLabel: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.selection-option-suggestion-label',
    defaultMessage: 'Suggest an improvement',
    description: 'The feedback dropdown list option to suggest an improvement',
  },
  selectionOptionDefaultLabel: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.selection-option-default-label',
    defaultMessage: 'Select feedback',
    description: 'The feedback dropdown list label',
  },
  selectionOptionDefaultPlaceholder: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.selection-option-default-placeholder',
    defaultMessage: 'Choose one',
    description: 'The feedback dropdown list placeholder',
  },
  feedbackIconLabel: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.feedback-icon-label',
    defaultMessage: 'Feedback',
    description: 'Accessibility text used for the feedback icon',
  },
  feedbackSuccessFlagDescription: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.feedback-success-flag-description',
    defaultMessage:
      'Your valuable feedback helps us continually improve our products.',
    description: 'Description shown when feedback is successfully submitted',
  },
  feedbackSuccessFlagTitle: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.feedback-success-flag-title',
    defaultMessage: 'Thanks!',
    description:
      'Button to dismiss success-flag flag after submitting feedback',
  },
  feedbackIsAnonymousTitle: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.feedback-is-anonymous-title',
    defaultMessage: 'Anonymous feedback',
    description: 'Section message title for anonymous feedback',
  },
  feedbackIsAnonymous: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.feedback-is-anonymous',
    defaultMessage:
      'This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback',
    description: 'Notice that feedback is anonymous',
  },
  requiredFieldsSummary: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.required-fields-summary',
    defaultMessage: 'Required fields are marked with an asterisk',
    description: 'Summary info of required fields asterisk.',
  },
  defaultCustomTextAreaLabel: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.default-custom-text-area-label',
    defaultMessage: 'Enter your feedback',
    description:
      'The textarea label where users can write their suggestion for custom feedback collector',
  },
  feedbackTypeLabel: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.feedback-type-label',
    defaultMessage: 'What is your feedback about?',
    description: 'Label for feedback type field',
  },
  feedbackSubTypeLabel: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.feedback-sub-type-label',
    defaultMessage: 'Select any relevant subcategories',
    description: 'Label for feedback sub type field',
  },
  generatedContent: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.generated-Content',
    defaultMessage: 'AI-generated content',
    description: 'The label for AI-generated content feedback category option',
  },
  ui: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.ui',
    defaultMessage: 'User experience',
    description: 'The label for user experience feedback category option',
  },
  suggestion: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.suggestion',
    defaultMessage: 'Idea or suggestion',
    description: 'The label for idea or suggestion feedback category option',
  },
  stuck: {
    id: 'frontbucket.repository.code-reviewer-feedback.modal.stuck',
    defaultMessage: 'I’m stuck and need help',
    description:
      'The label for requesting help when stuck feedback category option',
  },
});
